<template>
  <!--  -->
  <div class="app-content-wrapper">
    <div class="create-wrapper">
      <div>
        <el-image style="width: 184px; height: 169px" :src="require('../../../../assets/images/app.png')"></el-image>
      </div>
      <div class="right-wrapper">
        <template  v-if="acqWord">
          <div class="title">{{ $t('message.transfer.transferMoneyAcq') }}</div>
          <div class="description margin-top-5">{{ $t('message.transfer.addTransferMoneyDescriptionAcq') }}</div>
        </template>
        <template v-else>
          <div class="title">{{ $t('message.transfer.transferMoney') }}</div>
          <div class="description margin-top-5">{{ $t('message.transfer.addTransferMoneyDescription') }}</div>
        </template>
        <!-- <div class="description margin-top-5">{{ $t('message.transfer.addTransferMoneyDescription') }}</div> -->
        <!-- 商户业务类型为 B2B/B2C 时显示按钮 -->
        <el-button v-if="app.userLogin && (businessType === 'payout' || `${app.userLogin.businessType}` === '2')"
          v-permission="'transfer:transfer:add'" @click="addTransferMoney" type="primary" class="margin-top-15"
          size="small">{{
            $t('message.transfer.transferMoney') }}</el-button>
        <el-button v-if="app.userLogin && (businessType === 'payout' || `${app.userLogin.businessType}` === '2')"
          v-permission="'transfer:transfer:batchTransfer'" @click="batchTransferMoney" type="primary"
          class="margin-top-15" size="small">{{ $t('message.transfer.batchTransferMoney') }}</el-button>
      </div>
    </div>
    <div class="search-wrapper" style="padding-top: 20px;">
      <search-component ref="search" :search-condition="searchCondition" :search-buttons="searchButtonList"
        :fuzzySearchPlaceholder="fuzzySearchPlaceholder" :showMerchantSearch="true" :router-name="routeName">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition" ref="table" :service-function="getTransferList"
        :additional-parameters="getAdditionalParameters()" :first-parameters="getInitParams()"
        :is-first-automatic-visit="false" :showMerchantNo="true" :router-name="routeName">
        <template #payeeName="{ row }">
          <div class="account-name" style="font-weight: 800;">{{ row.payeeAccountName }}</div>
          <!-- <div class="payee-account">{{row.payeeAccount}}</div> -->
        </template>
      </custom-table>
    </div>
    <validation-modal ref="uploadModal" width="750px" :titleText="$t('message.settlement.restoreDetaileddeclaration')"
      @refresh="uploadSuccessHandler" :default-function="uploadFile" :validation-condition="uploadCondition">
      <template>
        <div class="upload-template">
          <el-link class="download" type="primary" href="/static/template/restoreDetailedDeclarationTemplate.xlsx"
            :download="`${$t('message.settlement.restoreDetaileddeclaration')}.xlsx`">
            <i class="iconfont icon-Download"></i>
            {{ $t('message.settlement.templateDownload') }}
          </el-link>
        </div>
      </template>
    </validation-modal>
    <validation-modal ref="batchTransferModal" width="750px" :titleText="batchTransferModalTitle"
      :default-function="uploadBatchTransfer" :validation-condition="batchTransferCondition"
      :customCloseState="customCloseState" :customCloseFn="customCloseFn" :isShowButton="showBatchTransferButton"
      :submitButtonText="batchTransferButtonText" :submitErrorMessage="batchTransferError" :showSubmitMessage="false"
      :submitDisabled="batchSubmitDisabled">
      <template>
        <template v-if="uploadStatus != ''">
          <div v-for="(item, index) in fileList" :key="index">
            <div class="rhch-file-list">
              <div class="rhch-file-item">
                <div class="item-left">
                  <span class="thumbnail-box" v-if="getFileType(item.name) === 'excel'">
                    <span class="thumbnail-icon-box">
                      <span class="iconfont icon-excl thumbnail" style="color: #79CF64;"></span>
                    </span>
                  </span>
                  <span class="thumbnail-box" v-else-if="getFileType(item.name) === 'word'">
                    <span class="thumbnail-icon-box">
                      <span class="iconfont icon-word thumbnail" style="color: #264373;"></span>
                    </span>
                  </span>
                  <span class="thumbnail-box img-box" v-else-if="getFileType(item.name) === 'image'">
                    <el-image :ref="`thumbnail${index}`" class="thumbnail-img" fit="cover" :src="item.url"
                      :preview-src-list="[item.url]"></el-image>
                  </span>
                  <span class="thumbnail-box" v-else>
                    <span class="thumbnail-icon-box">
                      <span class="iconfont icon-other1 thumbnail"></span>
                    </span>
                  </span>
                  <div>
                    <!-- 文件名 -->
                    <div class="rhcn-filename">Files {{ item.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="uploadStatus == 'pending' || uploadStatus == 'fail'">
            <div class="Progress-box">
              {{ $t('message.transfer.validationInpro') }}
            </div>
            <div class="Progress-box">
              {{ $t('message.transfer.validatedCount') }}{{ uploadStatusData.sumCount }} {{
                $t('message.transfer.validatedNum') }}
            </div>
            <div class="Progress-box">
              {{ $t('message.transfer.validatedS') }}：{{ uploadStatusData.successCount }}，{{
                $t('message.transfer.validatedF') }}：{{ uploadStatusData.failCount }}
            </div>
            <el-progress :percentage="progressRange"></el-progress>
          </div>
        </template>
        <template v-if="batchTransferResult.batchSize">
          <!-- 上传成功后的数据 -->
          <div class="batch-result-box margin-bottom-20">
            <!-- 付款总比数 batchTransferCount-->
            <p class="batch-result-title">{{ $t('message.transfer.batchTransferCount') }}</p>
            <div class="batch-result-content">
              <!-- countUnit 笔 -->
              {{ batchTransferResult.batchSize }}{{ $t('message.index.countUnit') }}
            </div>
          </div>
          <div class="batch-result-box margin-bottom-20">
            <!-- 付款总金额  b1atchTransferTotalAmount-->
            <p class="batch-result-title">{{ $t('message.transfer.b1atchTransferTotalAmount') }}</p>
            <!-- 总金额数据 -->
            <div class="batch-result-content">
              <p v-for="(item, index) in batchTransferResult.summaryAmountList" :key="index">
                <span>{{ item.totalAmount }}{{ item.currency }} + {{ `${item.totalFee}`.replace('-',
                  '') }}{{ item.currency }}</span>
              </p>
            </div>
          </div>
          <!-- vacancies暂不知数据来源 -->
          <div class="batch-result-box">
            <div class="batch-result-missing">
              <p v-for="(item, index) in batchTransferResult.vacancies" :key="index" class="margin-bottom-10">
                <span>{{ $t('message.transfer.missingError', {
                  currency: item.currency, availBalance: item.availBalance,
                  preDeductionAmount: item.preDeductionAmount, shortageAmount: item.shortageAmount
                }) }}</span>
              </p>
            </div>
          </div>
          <template v-if="!batchTransferResult.failFileUrl">
            <!-- 支付密码 -->
            <el-form ref="verifyCodeRef" class="verify-code-form" :model="form" :rules="rules">
              <el-form-item
                :label="paySafeConfigMode === 1 ?
                  `${$t('message.transfer.email')} / ${app && app.userLogin.operatorEmail}` : `${$t('message.validator.input', { input: $t('message.user.payPassword') })}`"
                prop="verifyCode">
                <div class="verify-code">
                  <el-input v-model="form.verifyCode" maxlength="6"
                    :type="paySafeConfigMode === 2 ? 'password' : 'text'" @input="onInputCode"></el-input>
                  <div v-if="paySafeConfigMode === 1" class="btn margin-left-13">
                    <el-button v-if="timerCountDown > 0" type="primary">{{ $t('message.user.restTime', {
                      time:
                        timerCountDown
                    }) }}</el-button>
                    <el-button v-else type="primary" @click="sendCode" :loading="verfifyCodeLoading">{{
                      $t('message.transfer.verfiyCode') }}</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </template>
        </template>
      </template>
    </validation-modal>
  </div>
</template>
<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';

import ValidationModal from '@/components/modal/base-modal/validation-modal.vue';
import { ShowSuccessMessage, ShowWarningMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component';
import { validateFns, REQUIRED } from '@/components/validation/tool/validator';
import { IS_PERMISSION_BUTTON } from '@/store/modules/permission';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { formatAmountByCurrency } from '@/utils/tools/currency';
import { initToday, getTodayParams } from '@/utils/tools/time';
import { getPaySafeConfig } from '@/views/account/security/api/security';
import DisbursementService from '@/views/settlement/api/disbursement';
import DeclarationService from '@/views/settlement/api/restore-detailed-declaration';
import TransferService from '@/views/transfer/api/transfer';
export default {
  components: { SearchComponent, CustomTable, ValidationModal },
  data() {
    return {
      ...DeclarationService,
      fuzzySearchPlaceholder: `${this.$t('message.transfer.transferId')},${this.$t('message.transfer.fileBatchNo')}`,
      searchCondition: [
        { // 付款状态
          key: 'payoutStatus',
          name: 'message.transfer.payStatus',
          type: 'select',
          defValue: '',
          options: [],
        },
        { // 创建时间
          key: ['createTimeStartTime', 'createTimeEndTime'],
          name: 'message.payee.creationTime',
          defValue: initToday(),
          type: 'date_time',
        },
        { // 付款时间
          key: ['payoutStartTime', 'payoutEndTime'],
          name: 'message.transfer.payTime',
          type: 'date_time',
        },
        { // 付款方式
          key: 'payoutMethod',
          name: 'message.transfer.paymentMethod',
          type: 'select',
          defValue: '',
          options: [],
        },
      ],
      searchButtonList: [],
      tableCondition: [
        { // Create date
          titleBar: { type: 'text', title: 'message.payee.creationTime' },
          key: 'createTime',
          type: 'text',
        },
        { // Batch no
          titleBar: { type: 'text', title: 'message.transfer.fileBatchNo' },
          key: 'batchNo',
          type: 'text',
        },
        { // Transfer ID
          titleBar: { type: 'text', title: 'message.transfer.transferId' },
          key: 'id',
          type: 'click',
          subTableDisplays: [
            {
              type: 'text_button',
              key: 'id',
              isDisplayFunc: () => {
                return this.isHasViewAuth();
              },
              func: (data) => {
                window.open(`/transfer/transfer/view?id=${data.id}&businessType=${this.businessType}`, '_blank');
              },
            },
            {
              type: 'text',
              key: 'id',
              isDisplayFunc: () => !this.isHasViewAuth(),
            },
          ],
        },
        { // Beneficiary
          titleBar: { type: 'text', title: 'message.transfer.beneficiary' },
          key: 'payeeName',
          type: 'slot',
        },
        { // Send Amount
          titleBar: { type: 'text', title: 'message.transfer.sendAmount' },
          key: 'settleSumAmount',
          type: 'text',
          textFunc: (row) => {
            if (row.settleSumAmount === null) {
              return '--';
            }
            return `${row.settleSumAmount} ${row.settleCurrency}`;
          },
        },
        { // Received Amount
          titleBar: { type: 'text', title: 'message.transfer.amountReceived1' },
          key: 'payoutAmount',
          type: 'text',
          textFunc: (row) => {
            if (!row.payoutAmount) {
              return '--';
            }
            return `${formatAmountByCurrency(row.payoutAmount, row.payoutCurrency)} ${row.payoutCurrency}`;
          },
        },
        { // 付款方式
          titleBar: { type: 'text', title: 'message.transfer.paymentMethod' },
          key: 'payoutMethod',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.transferMethodList, row.payoutMethod),
        },
        { // Completion time
          titleBar: { type: 'text', title: 'message.transfer.payTime' },
          key: 'payoutTime',
          type: 'text',
        },
        { // 付款方名称
          titleBar: { type: 'text', title: 'message.payoutInfo.payerName' },
          key: 'payerCompanyName',
          type: 'text',
        },
        { // status
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'payoutStatus',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.payoutStatusList, row.payoutStatus),
          itemStyle: (data) => {
            const style = 'height: 27px;text-align: center;border-radius:4px;font-weight: 800;line-height: 27px;padding: 0 15px;';
            if (data.payoutStatus === 'S') { // 成功
              return `background:rgba(0,221,40,0.15);${style}`;
            } else if (['P', 'A', 'I'].indexOf(data.payoutStatus) > -1) { // 处理中,待审核,初始化
              return `background:rgba(255,178,9,0.15);${style}`;
            } else if (data.payoutStatus === 'C') { // 撤销
              return `background:#F1F5F7;${style}`;
            }
            return `background:rgba(252,100,45,0.15);${style}`; // SF, F, U, E, R
          },
        },
        {
          titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
          key: 'operations',
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.see',
              permissionCode: 'transfer:transfer:detail',
              func: (data) => {
                this.$router.push({
                  path: '/transfer/transfer/view',
                  query: { id: data.id },
                });
              },
            },
            { // 出款方式为【代出款】显示此下载按钮
              type: 'text_button',
              textFunc: () => 'message.transfer.receiptDownload',
              permissionCode: 'transfer:transfer:receiptDownload',
              isDisplayFunc: (data) => {
                return data.payoutType === 'SETTLE';
              },
              func: async (data) => {
                await DisbursementService.downloadDisbursement({ payoutId: data.id });
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.transfer.payoutVoucher',
              permissionCode: 'transfer:transfer:downloadPayoutVoucher',
              isDisplayFunc: (data) => (this.businessType === 'payout' && data.payoutStatus === 'S'),
              func: async (data) => {
                if (this.downloadingCertificate) {
                  return;
                }
                this.downloadingCertificate = true;
                try {
                  await TransferService.downloadCertificate({ payoutId: data.id });
                  ShowSuccessMessage(this.$t('message.downloadSuccessfulTip'));
                } catch (err) {
                }
                this.downloadingCertificate = false;
              },
            },
          ],
        },
      ],
      payoutStatusList: [],
      transferMethodList: [],
      fileList: [],
      fileTypes: {
        excel: ['csv', 'xls', 'xlsx'],
        word: ['doc', 'docx'],
        image: ['jpg', 'png', 'gif', 'bmp', 'jpeg'],
      },
      uploadCondition: [
        {
          key: 'appId',
          name: 'message.tableCommon.appName',
          type: 'select',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          options: [],
          option: {
            label: 'appName',
            value: 'id',
          },
          itemWidth: '470px',
        },
        {
          key: 'fileName',
          name: 'message.settlement.uploadFile',
          type: 'upload_file',
          defValue: '',
          isShowStar: true,
          uploadRange: {
            fileSize: 100, // 100M
            uploadFileList: [],
            fileTypeRule: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: '.xlsx' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'xlsx' }),
          },
        },
      ],
      batchTransferCondition: [
        {
          key: 'fileName',
          name: 'message.settlement.uploadFile',
          type: 'upload_file',
          defValue: '',
          isShowStar: true,
          onRemove: () => {
            this.batchTransferError = '';
          },
          uploadRange: {
            fileSize: 100, // 100M
            uploadFileList: [],
            fileTypeRule: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: '.xlsx' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'xlsx' }),
            templateFileName: '/static/template/batchTransferTemplate.xlsx',
            templateFileNameShow: `${this.$t('message.transfer.batchTransferTemplate')}.xlsx`,
            hideSuccessMessage: true,
            hideErrorMessage: true,
            fileUploadFunc: async (file) => {
              const loading = this.$loading();
              // this.customCloseFnSta = this.customCloseFn();
              // try {
              //   const res = await TransferService.batchPaymentUpload(file);
              //   this.batchTransferResult = res;
              //   this.batchTransferError = '';
              //   this.batchTransferButtonText = '';
              //   // 按钮是否禁用
              //   this.batchSubmitDisabled = false;
              //   // 本次批量付款文件汇总batchTransferResultTitle
              //   this.batchTransferModalTitle = this.$t('message.transfer.batchTransferResultTitle');
              //   // 上传失败的情况
              //   if (res.failFileUrl) {
              //     if (!res.batchSize) {
              //       // 上传批量付款文件 batchTransferModalTitle
              //       this.batchTransferModalTitle = this.$t('message.transfer.batchTransferModalTitle');
              //       // 下载报表
              //       this.batchTransferButtonText = this.$t('message.transfer.downloadReport');
              //       // 名单导入文件有错误，请下载报表查看详情
              //       this.batchTransferError = this.$t('message.transfer.batchFileError');
              //     } else {
              //       // 无法完成付款
              //       this.batchTransferError = this.$t('message.transfer.batchTransferError');
              //       // 下载当前报表
              //       this.batchTransferButtonText = this.$t('message.transfer.downloadCurReport');
              //     }
              //   } else {
              //     this.batchSubmitDisabled = true;
              //   }
              //   this.$refs.batchTransferModal.getForm().setItemHide('fileName', !!res.batchSize);
              //   this.showBatchTransferButton = true;
              //   loading.close();
              //   return {
              //     fileUrl: res.failFileUrl,
              //   };
              // } catch (err) {
              //   loading.close();
              //   console.log(err);
              //   throw err;
              // }
              if (this.businessType) {
                file.businessType = this.businessType;
              }
              try {
                const res = await TransferService.batchPaymentUpload(file);
                this.fileList.push(file);
                // console.log(file, this.fileList);
                // console.log('res', res);
                if (res && !res.failFileUrl) {
                  this.taskId = res.taskId;
                  this.$refs.batchTransferModal.getForm().setItemHide('fileName', true);
                  this.uploadStatus = 'pending';
                  this.uploadStatusData.sumCount = res.sumCount;
                  this.customCloseState = false;
                  this.setInt();
                } else {
                  Message.error({ res });
                }
              } catch (err) {
                loading.close();
                console.log(err);
                throw err;
              }
            },
          },
        },
      ],
      showBatchTransferButton: false,
      batchTransferButtonText: '',
      batchTransferError: '',
      batchTransferResult: {},
      batchTransferModalTitle: '',
      verfifyCodeLoading: false,
      form: {
        verifyCode: '',
        requestId: '',
      },
      rules: {
        verifyCode: [
          { validator: validateFns([REQUIRED]) },
        ],
      },
      timerCountDown: 0,
      batchSubmitDisabled: false,
      paySafeConfigMode: 1,
      progressRange: 0,
      showProgress: false,
      // 定时器
      timerSet: null,
      uploadStatus: '',
      uploadStatusData: {
        sumCount: 0,
        successCount: 0,
        failCount: 0,
      },
      customCloseFnSta: null,
      customCloseState: true,
      routeName: '',
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.params?.type || '';
    },
    acqWord() {
      if (this.businessType && this.businessType === 'acq') {
        return true;
      } else if (this.app.userLogin && `${this.app.userLogin.businessType}` === '1' && !this.businessType) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.getAppList().then((res) => {
      this.uploadCondition[0].options = res;
    });
    if (this.businessType === 'payout') {
      this.searchButtonList.unshift({
        type: 'download',
        name: 'message.transaction.download',
        permissionCode: 'transfer:transfer:download',
        func: async (param) => {
          if (!this.downloading) {
            this.downloading = true;
            try {
              await this.downloadTransferList(param);
              ShowSuccessMessage(this.$t('message.common.downloadTask'));
            } catch (err) {
              //
            }
            this.downloading = false;
          }
        },
      });
      this.searchButtonList.unshift({
        type: 'other',
        name: 'message.transfer.payoutVoucherBatch',
        permissionCode: 'transfer:transfer:payoutVoucherBatch',
        func: async (params) => {
          if (this.downloadingBatchCertificate) {
            return;
          }
          this.downloadingBatchCertificate = true;
          try {
            await TransferService.batchDownloadCertificate(params);
            ShowSuccessMessage(this.$t('message.common.downloadTask'));
          } catch (err) {
          }
          this.downloadingBatchCertificate = false;
        },
      });
    } else {
      this.searchButtonList.unshift({
        type: 'download',
        name: 'message.common.download',
        permissionCode: 'transfer:transfer:download',
        func: async (param) => {
          if (!this.downloading) {
            this.downloading = true;
            try {
              await this.downloadTransferList(param);
              ShowSuccessMessage(this.$t('message.common.downloadTask'));
            } catch (err) {
              //
            }
            this.downloading = false;
          }
        },
      });
      this.searchButtonList.unshift({
        type: 'other',
        name: 'message.transfer.uploadRestoreDetails',
        buttonType: 'default',
        permissionCode: 'transfer.transfer.uploadDeclaration',
        func: () => {
          this.$refs.uploadModal.openModal(true);
        },
      });
      this.tableCondition.splice(8, 0, { // 风控冻结金额
        titleBar: { type: 'text', title: 'message.transfer.frozenAmount' },
        key: 'frozenAmount',
        type: 'text',
      });
    }
  },
  mounted() {
    this.initMethod();
    console.log('routeName', this.$route.path);
    console.log('2222222222', `/transfer/transfer/index_aggregate/${this.businessType}`);
  },
  methods: {
    getFileType(fileName) {
      const fileNameArr = fileName.split('.');
      const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
      if (this.fileTypes.excel.indexOf(ext) > -1) {
        return 'excel';
      }
      if (this.fileTypes.word.indexOf(ext) > -1) {
        return 'word';
      }
      if (this.fileTypes.image.indexOf(ext) > -1) {
        return 'image';
      }
      return '';
    },
    customCloseFn() {
      if (this.uploadStatus === 'pending') {
        return this.closeDemo();
      } else {
        // console.log('222');
        return null;
      }
    },
    closeDemo() {
      this.$confirm(this.$t('message.transfer.confirmWord'), this.$t('message.common.prompt'), {
        confirmButtonText: this.$t('message.common.confirm'),
        cancelButtonText: this.$t('message.tableCommon.cancel'),
        type: 'warning',
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('message.alert.closed'),
        });
        this.clearOver();
        // this.customCloseFn = null;
        this.$refs.batchTransferModal.closeMoadalFn();
        this.$refs.batchTransferModal.closeDialogFn();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('message.subscription.statusData[3]'),
        });
      });
    },
    async initMethod() {
      await GlobalData.getDictList(['MER_PAYOUT_STATUS', 'TRANSFER_METHOD']).then((res) => {
        this.payoutStatusList = initSelectedData(res.MER_PAYOUT_STATUS); // 付款状态
        this.$refs.search.setSearchSelectOptions('payoutStatus', this.payoutStatusList);
        this.transferMethodList = initSelectedData(res.TRANSFER_METHOD); // 付款方式
        this.$refs.search.setSearchSelectOptions('payoutMethod', this.transferMethodList);
      });
      if (this.$store.getters.permission.permissionCodes.includes('transfer:transfer:batchTransfer')) {
        try {
          const res = await getPaySafeConfig();
          this.paySafeConfigMode = +res.mode === 2 ? 2 : 1; // 2：支付密码验证  1：邮箱验证
        } catch (err) {
          //
        }
      }
      if (this.businessType) {
        this.routeName = `/transfer/transfer/aggregate/${this.businessType}`;
      } else {
        this.routeName = '/transfer/transfer';
      }
      console.log('routeName', this.routeName);
      this.$refs.table.firstVisitHttp();
    },
    addTransferMoney() {
      if (this.businessType) {
        this.$router.push({
          path: '/transfer/transfer/add/recipient',
          query: {
            businessType: this.businessType,
          },
        });
      } else {
        this.$router.push({
          path: '/transfer/transfer/add/recipient',
        });
      }
    },
    batchTransferMoney() {
      if (`${this.app.userLogin.merchantStatus}` === '4') { // 未启用时，弹出提示
        this.$bus.$emit('showAuditStatusAlert');
        return;
      }
      this.uploadStatusData.sumCount = 0;
      this.uploadStatusData.successCount = 0;
      this.uploadStatusData.failCount = 0;
      this.progressRange = 0;
      this.uploadStatus = '';
      this.fileList = [];
      this.customCloseState = true;
      this.form.verifyCode = '';
      this.batchTransferResult = {};
      this.showBatchTransferButton = false;
      this.batchTransferError = '';
      this.batchTransferButtonText = '';
      this.batchTransferModalTitle = this.$t('message.transfer.batchTransferModalTitle');
      this.$refs.batchTransferModal.openModalAndCallBack((form) => {
        this.batchTransferCondition[0].uploadRange.uploadFileList = [];
        form.setItemHide('fileName', false);
      });
    },
    async uploadBatchTransfer(params) {
      if (this.batchTransferResult.failFileUrl) {
        window.location.href = this.batchTransferResult.failFileUrl;
        return {};
      }
      const valid = await this.$refs.verifyCodeRef.validate();
      if (valid) {
        if (this.paySafeConfigMode === 1 && !this.form.requestId) {
          const errMsg = this.$t('message.transfer.needCode');
          ShowWarningMessage(errMsg);
          throw new Error(errMsg);
        }

        await TransferService.batchPayment(params.fileNameFile, { taskId: this.taskId, requestId: this.form.requestId, verifyCode: this.form.verifyCode });
        this.$router.push({
          path: '/content/upload',
        });
      }
    },
    getInitParams() {
      const params = getTodayParams('createTimeStartTime', 'createTimeEndTime');
      params.businessType = this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null;
      return params;
    },
    uploadFile(params) {
      if (!params.fileNameFile) {
        ShowWarningMessage(this.$t('message.emptyUploadFileTip'));
        return Promise.reject(new Error(this.$t('message.emptyUploadFileTip')));
      }
      const data = new FormData();
      data.append('upfile', params.fileNameFile);
      data.append('appId', params.appId);
      return this.uploadDeclarationFile(data);
    },
    uploadSuccessHandler() {
      // console.log('222');
      this.$router.push({
        path: '/content/upload',
      });
    },
    getAdditionalParameters() {
      const businessType = this.businessType ? (this.businessType === 'payout' ? 'PAYOUT' : 'ACQUIRING') : null;
      return {
        businessType,
      };
    },
    setInt() {
      this.timerSet = setInterval(async () => {
        const params = {};
        params.taskId = this.taskId;
        const res = await TransferService.queryVerifyResult(params);
        if (res) {
          this.uploadStatusData.sumCount = res.sumCount;
          this.uploadStatusData.successCount = res.successCount;
          this.uploadStatusData.failCount = res.failCount;
          // this.progressRange = (Number(res.successCount) / Number(res.sumCount) * 100).toFixed();
          const progressRange = ((Number(res.successCount) + Number(res.failCount)) / (Number(res.sumCount)) * 100).toFixed();
          if (progressRange >= 90) {
            this.progressRange = 90;
          } else {
            this.progressRange = progressRange;
          }
        }
        // 文件有问题
        // const res = {
        //   merchantNo: null,
        //   batchSize: null,
        //   summaryAmountList: null,
        //   vacancies: null,
        //   failFileUrl: 'https://ronhandevopsdiag.blob.core.windows.net/overt/operation-web-uat/failFile/%E6%89%B9%E9%87%8F%E4%BB%98%E6%AC%BE%E5%A4%B1%E8%B4%A5%E6%96%87%E4%BB%B6-20241213140721727.xlsx',
        //   failMsg: null,
        //   taskCompletion: true,
        //   sumCount: 10,
        //   successCount: 5,
        //   failCount: 1,

        // };
        // 成功
        // const res =
        // {
        //   merchantNo: '800225',
        //   batchSize: 2,
        //   summaryAmountList: [
        //     {
        //       currency: 'USD',
        //       totalAmount: '0.20',
        //       totalFee: '-2.09',
        //     },
        //   ],
        //   vacancies: null,
        //   failFileUrl: null,
        //   failMsg: null,
        //   taskCompletion: true,
        //   sumCount: 10,
        //   successCount: 5,
        //   failCount: 1,
        // };
        // 校验结束
        // const res = {
        //   taskCompletion: true,
        //   sumCount: 10,
        //   successCount: 5,
        //   failCount: 1,
        //   merchantNo: '800225',
        //   batchSize: 2,
        //   summaryAmountList: [
        //     {
        //       currency: 'USD',
        //       totalAmount: '10000.10',
        //       totalFee: '-2.09',
        //     },
        //   ],
        //   vacancies: [
        //     {
        //       currency: 'USD',
        //       availBalance: '9825.65',
        //       preDeductionAmount: '10002.19',
        //       shortageAmount: '176.55',
        //     },
        //   ],
        //   failFileUrl: 'https://ronhandevopsdiag.blob.core.windows.net/overt/operation-web-uat/failFile/20241213145613823/%E6%89%B9%E9%87%8F%E4%BB%98%E6%AC%BE%E5%A4%B1%E8%B4%A5%E6%96%87%E4%BB%B6.txt',
        //   failMsg: '下发总笔数: 2\n下发总金额: 10000.10 USD   +   2.09 USD (手续费)\n\n当前 USD 账户可用余额为 9825.65，预扣除总额度 10002.19，缺少 176.55\n\n无法完成付款，请充值或者修改批量付款文件后重试',
        // };
        if (res.respCode === '5000') {
          this.$refs.batchTransferModal.closeMoadalFn();
          this.$refs.batchTransferModal.closeDialogFn();
          ShowErrorMessage(res.respMsg);
          this.clearOver();
          return;
        }

        if (res.taskStatus === 'F') {
          this.$refs.batchTransferModal.closeMoadalFn();
          this.$refs.batchTransferModal.closeDialogFn();
          ShowErrorMessage(this.$t('message.transfer.taskErr'));

          this.clearOver();
          return;
        }
        if (res.taskStatus === 'S') {
          this.batchTransferResult = res;
          this.batchTransferError = '';
          this.batchTransferButtonText = '';
          // 按钮是否禁用
          this.batchSubmitDisabled = false;
          // 本次批量付款文件汇总batchTransferResultTitle
          this.batchTransferModalTitle = this.$t('message.transfer.batchTransferResultTitle');
          // 上传失败的情况
          if (res.failFileUrl) {
            this.clearOver();

            if (!res.batchSize) {
              this.uploadStatus = 'fail';
              this.customCloseState = true;
              // 上传批量付款文件 batchTransferModalTitle
              this.batchTransferModalTitle = this.$t('message.transfer.batchTransferModalTitle');
              // 下载报表
              this.batchTransferButtonText = this.$t('message.transfer.downloadReport');
              // 名单导入文件有错误，请下载报表查看详情
              this.batchTransferError = this.$t('message.transfer.batchFileError');
            } else {
              this.customCloseState = true;
              this.uploadStatus = '';
              this.fileList = [];
              // 无法完成付款
              this.batchTransferError = this.$t('message.transfer.batchTransferError');
              // 下载当前报表
              this.batchTransferButtonText = this.$t('message.transfer.downloadCurReport');
            }
          } else {
            this.clearOver();
            this.customCloseState = true;

            this.uploadStatus = '';
            // 走到这了
            this.fileList = [];
          }
          this.showBatchTransferButton = true;
          this.customCloseState = true;
        }
        // 原处理逻
      }, 1000);
      // 袁
    },
    // 停止轮询
    async clearOver() {
      clearInterval(this.timerSet);
      // console.log('停止轮询');
      // if (!type) {
      //   this.uploadStatus = '';
      //   this.fileList = [];
      // }
      const params = {
        taskId: this.taskId,
      };
      await TransferService.stopVerify(params);
    },
    onInputCode(val) {
      this.batchSubmitDisabled = !val;
    },
    sendCode() {
      if (this.timerCountDown > 0) { // 倒计时中
        return;
      }
      this.verfifyCodeLoading = true;
      TransferService.sendTransferVerifyCode().then((res) => {
        this.verfifyCodeLoading = false;
        this.form.requestId = res;
        ShowSuccessMessage(this.$t('message.transfer.verfiyCodeTip'));
        this.timerCountDown = 59;
        this.timer = setInterval(() => {
          this.timerCountDown -= 1;
          if (this.timerCountDown <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }).catch((err) => {
        console.log(err);
        this.verfifyCodeLoading = false;
      });
    },
    isHasViewAuth() {
      return this.$store.getters[IS_PERMISSION_BUTTON]('transfer:transfer:detail');
    },
    ...TransferService,
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.rhch-file-list {
  width: 100%;
  min-width: 590px;
  margin-bottom: 20px;

  .rhch-file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 2px solid $color-default;
    margin-top: 10px;
    height: 80px;
    box-sizing: border-box;
    padding: 0 16px;

    .item-left {
      display: flex;
      align-items: center;
    }

    .thumbnail-box {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 65px;
      text-align: center;
      position: relative;
      margin-right: 18px;

      .thumbnail-icon-box {
        display: inline-block;
        background: $color-default;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        position: relative;
      }

      &.img-box {
        border-radius: 0;
        height: 54px;
      }

      .thumbnail-img {
        width: 65px;
        height: 54px;
        pointer-events: none;
      }

      .thumbnail {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 33px;
      }
    }

    .rhcn-filename {
      font-size: 14px;
      line-height: 36px;
      font-weight: 800;
      color: $color-text-primary;
      // margin-top: -5px;
    }

    .rhcn-description {
      font-size: 12px;
      font-weight: normal;
      color: $color-text-primary;
      line-height: 16px;

      .rhch-filesize {
        margin-right: 10px;
      }
    }

    .rhch-acctions {
      display: flex;
      align-items: center;
      color: $color-primary;

      .rhch-action {
        display: inline-block;
        width: 34px;
        height: 34px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;

        &:nth-child(n+2) {
          margin-left: 10px;
        }

        &:hover {
          background: $color-default;
        }

        &:active {
          background: $color-default-active;
        }
      }

      .el-icon-close {
        font-size: 25px;
        font-weight: 800;
      }
    }
  }
}

.app-content-wrapper {
  color: $color-text-primary;

  .create-wrapper {
    display: flex;
    align-items: center;

    .right-wrapper {
      padding-left: 10px;

      .title {
        font-size: 16px;
        font-weight: 800;
        color: $color-text-primary;
        line-height: 28px;
      }

      .description {
        font-size: 14px;
        font-weight: normal;
        color: $color-text-primary;
        line-height: 21px;
      }
    }
  }
}

.upload-template {
  position: absolute;
  top: 123px;
  right: 30px;
  height: 32px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: $color-text-default-button;

  .icon-Download {
    font-weight: 400;
    font-size: 14px;
  }
}
</style>
<style lang="scss">
@import '@/styles/variables.scss';

.batch-result-box {
  display: flex;
  align-items: flex-start;

  .batch-result-title {
    color: $color-text-primary;
    font-weight: 800;
    font-size: 14px;
    width: 180px;
  }

  .batch-result-content {
    color: $color-text-primary;
    font-size: 14px;
  }

  .batch-result-missing {
    color: $color-text-primary;
    font-weight: 800;
    font-size: 14px;
  }
}

.verify-code-form {
  margin-top: 20px;

  .el-form-item__label {
    line-height: 20px;
    margin-bottom: 5px;
    font-weight: 600;
  }

  .verify-code {
    display: flex;
    width: 100%;

    .el-button {
      min-width: 180px;
      background-color: $color-text-primary;
      border-color: $color-text-primary;
    }
  }
}

.Progress-box {
  text-align: center;
  margin-bottom: 20px;
}
</style>
